module.exports = __webpack_public_path__ + "f047648ebeaabd2791719f6ae1b6ad79.fbx";